<div class="character-selection-container scroll">
  <div class="character-list">
    <div
      *ngFor="let character of newcharacters"
      (click)="selectCharacter(character)"
      class="character"
      [ngClass]="{
        picked: pickedCharacter?.id === character.id,
        ready: character.character
          ? character.character.energy.quantity > 0
          : false,
        noenergy: character.character
          ? character.character.energy.quantity === 0 ||
            character.character.status !== 'FREE'
          : true
      }"
    >
      <div class="name">
        {{ character.character ? character.character.name : "" }}
      </div>
      <div class="character-icon-container bg-{{ character.sequenceNumber }}">
        <div
          *ngIf="character.character?.status === 'BUSY'"
          class="status BUSY"
        ></div>
        <div
          *ngIf="pickedCharacter?.id === character.id"
          class="status SELECTED"
        ></div>

        <app-character-skin
          [config]="character.character ? character.character.skin : undefined"
        ></app-character-skin>
        <div class="energy-bar">
          <app-progress-bar-with-level
            [type]="'ENERGY'"
            [energy]="
              character.character ? character.character.energy.quantity : 0
            "
            [progress]="
              character.character
                ? character.character.energy.quantityInPercent
                : 0
            "
          ></app-progress-bar-with-level>
        </div>
      </div>
      <div class="character-skills-container">
        <div
          class="skill {{ skill.displayName }}"
          *ngFor="let skill of character.character?.specialities"
        >
          <div class="text">{{ skill.config?.speciality }}</div>
          <div class="proggres">
            <app-progress-bar-with-level
              [type]="skill.config ? skill.config.speciality : ''"
              [progress]="skill.progress"
              [level]="skill.speciality.level"
              [smallProgressScale]="true"
            ></app-progress-bar-with-level>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
